import { createGlobalPersistedVariable } from './createGlobalPersistedVariable'

interface PersistedMenuPageScrollSettings {
  menuPageId: string
  pageYOffset: number
}

export default createGlobalPersistedVariable<PersistedMenuPageScrollSettings | null>(null, 'persistedMenuPageScrollSettings')
